import { Link } from "react-router-dom";
import { Space, Breadcrumb, Button } from "antd";
import type { ColumnsType } from "antd/es/table";
import { PageHeader } from "@ant-design/pro-layout";

import { Site, ZoneConfig } from "../../model/model";
import SessionStore from "../../model/SessionStore";
import type { GetPageCallbackFunc } from "../../components/DataTable";
import DataTable from "../../components/DataTable";

interface IProps {
  site: Site;
}

function ListSiteZones(props: IProps) {
  const columns: ColumnsType<ZoneConfig> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Link to={`/site/${props.site.id}/zone/${record.id}`}>{record.name}</Link>
      ),
    },
    {
      title: "Device ID",
      dataIndex: "devId",
      key: "devId",
    },
    {
      title: "Check Interval (s)",
      dataIndex: "checkIntervalSecond",
      key: "checkIntervalSecond",
    },
  ];

  const getPage = (limit: number, offset: number, callbackFunc: GetPageCallbackFunc) => {
    SessionStore.getClient()
      .getZoneConfigBySite(props.site.id, SessionStore.getBearer())
      .then((resp) => {
        const obj = resp.data;
        callbackFunc(obj.length, obj);
      });
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Sites</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/site/${props.site.id}/dash`}>{props.site.name}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Zone Configs</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Zone Configs"
        extra={[
          <Button type="primary" key="create">
            <Link to={`/site/${props.site.id}/zones/create`}>Add Zone Config</Link>
          </Button>,
        ]}
      />
      <DataTable columns={columns} getPage={getPage} rowKey="id" />
    </Space>
  );
}

export default ListSiteZones;
